var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":_vm.$t('product.description')}},[_c('div',{staticClass:"product--details",domProps:{"innerHTML":_vm._s(_vm.htmlContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }